import { render, staticRenderFns } from "./DentatsuMailMstEditModal.vue?vue&type=template&id=fbbd3e38&scoped=true&"
import script from "./DentatsuMailMstEditModal.vue?vue&type=script&lang=js&"
export * from "./DentatsuMailMstEditModal.vue?vue&type=script&lang=js&"
import style0 from "./DentatsuMailMstEditModal.vue?vue&type=style&index=0&id=fbbd3e38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbbd3e38",
  null
  
)

export default component.exports